import { createFileRoute } from "@tanstack/react-router";
import { EditTemplateForm } from "@/features/consent-solutions";

export const Route = createFileRoute(
  "/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/",
)({
  component: () => <EditTemplateForm />,
});
